export const USER_ROLE_TEACHER = 0;
export const USER_ROLE_EDITOR = 1;
export const USER_ROLE_BOTH = 2;
// export const ROUTE_NAME_PROTECTED = "protected";
// export const ROUTE_NAME_PROFILE = "profile";